import React from "react";
import * as _ from "lodash";

type LogosProps = {
	logos: {
		title: string;
		src: string;
		url: string;
	}[];
};

export default function Logos({ logos }: LogosProps) {
	return (
		<div className="logos-list tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-3.5">
			{logos.map(({ title, src, url }) => (
				<div
					key={_.camelCase(title)}
					className="badge tw-flex tw-flex-1 tw-items-center tw-justify-center tw-rounded tw-border tw-border-line tw-bg-white tw-text-muted"
				>
					<a href={url} target="_blank" rel="noopener noreferrer">
						{src ? <img src={src} alt={title} /> : title}
					</a>
				</div>
			))}
		</div>
	);
}
